import {priority} from '@priority-software/priority-proto-api/lib';
import {action, observable, computed, makeObservable} from 'mobx';
import {Form} from './Form';
import {
    boolWidth,
    charWidth,
    defaultWidth,
    inputButtonWidth
} from '../../features/Form/consts/formInput';

export type linkData = {
    from: number;
    len: number;
    title: string;
    linkData: {
        eName: string;
    };
}[];

export type helpMessage = {
    content: string;
    linkData: linkData;
};

export class Column extends priority.netitems.form.Column {
    parentForm: Form;
    columnIndex: number = -1;
    helpMessage?: helpMessage;
    columnWidth: number = 0;
    defaultColumnWidth: number = 0;
    minWidth: number = 110;
    @observable editMode: boolean = false;
    @observable maxWidthMode: boolean = false;

    constructor(form: Form, properties: priority.netitems.form.IColumn) {
        super(properties);

        makeObservable(this);

        const additionalWidth =
            this.Zoom !== priority.netitems.form.ZoomType.NoneZoom ? inputButtonWidth : 0;
        const storedColumnWidth = form.customColumnsWidth[properties.ID as number];

        this.parentForm = form;
        this.defaultColumnWidth = defaultWidth + additionalWidth;
        this.columnWidth = storedColumnWidth || this.defaultColumnWidth;
    }

    setWidth(width: number) {
        this.columnWidth = width;
    }

    get id(): number {
        return Number(this.ID);
    }

    get index(): number {
        return this.columnIndex;
    }

    get maxLength(): number {
        return Number(this.Width);
    }

    get decimal(): number {
        return Number(this.Decimal);
    }

    get hidden(): boolean {
        return this.Hidden;
    }

    @computed
    get width(): number {
        if (this.Type === priority.netitems.form.ColumnType.Boolean) {
            return boolWidth;
        }

        if (this.maxWidthMode) {
            return this.maxWidth;
        } else {
            return this.columnWidth;
        }
    }

    get maxWidth(): number {
        return Math.max(Number(this.Width) * charWidth, this.defaultColumnWidth);
    }

    get relatedIdColumn(): Column {
        return this.parentForm.columns.find(column => column.ID === this.Relcol);
    }

    get isReadonly(): boolean {
        return this.Readonly;
    }

    setHelpMessage = (msg: helpMessage) => {
        this.helpMessage = msg;
    };

    setColumnIndex = (idx: number) => {
        this.columnIndex = idx;
    };

    @action
    setEditMode = (value: boolean) => {
        this.editMode = value;
        this.maxWidthMode = value;
    };

    @action
    setMaxWidthMode = (value: boolean) => {
        this.maxWidthMode = value;
    };
}
